import { KojinResult } from "interface/kojin"

export type SisetuDoctorsCondition = {
  code: string
  name: string
}
export type SisetuDoctorsNenreiCondition = {
  start?: number;
  last?: number;
  seibetu?: string;
  name: string;
}
export interface SisetuDoctorsConditions {
  nenrei?: SisetuDoctorsNenreiCondition
  isikai?: SisetuDoctorsCondition
  sinryoka?: SisetuDoctorsCondition
  sotukou?: SisetuDoctorsCondition
  collabo?: SisetuDoctorsCondition
  senmoni?: SisetuDoctorsCondition
  gakkai?: SisetuDoctorsCondition
  buka?: SisetuDoctorsCondition
  memberClass?: SisetuDoctorsCondition
}
export type SisetuDoctorsConditionsAxis = keyof SisetuDoctorsConditions

export const isValid = (
  sisetuCode: string | null | undefined,
  conditions: SisetuDoctorsConditions,
  kojin: KojinResult,
  exclude?: SisetuDoctorsConditionsAxis
) => {
  if (exclude !== 'nenrei' && conditions.nenrei) {
    if (!kojin.nenrei || 
        (conditions.nenrei.start && conditions.nenrei.start > kojin.nenrei) ||
        (conditions.nenrei.last && conditions.nenrei.last <= kojin.nenrei)) return false;
    if (!kojin.seibetuCode || (conditions.nenrei.seibetu && conditions.nenrei.seibetu !== kojin.seibetuCode)) return false;
  }
  if (exclude !== 'sinryoka' && conditions.sinryoka) {
    if (!kojin.sinryoka?.some((s) => s.sinryokaCode === conditions.sinryoka?.code)) return false;
  }
  if (exclude !== 'sotukou' && conditions.sotukou) {
    if (!kojin.sotukouCode || (conditions.sotukou.code !== kojin.sotukouCode)) return false;
  }
  if (exclude !== 'gakkai' && conditions.gakkai) {
    if (!kojin.gakkai?.some((g) => g.gakkaiCode === conditions?.gakkai?.code)) return false;
  }
  if (exclude !== 'senmoni' && conditions.senmoni) {
    if (!kojin.senmoni?.some((s) => s.senmoniCode === conditions?.senmoni?.code)) return false;
  }
  if (exclude !== 'isikai' && conditions.isikai) {
    if (!kojin.isikaiCode || (conditions.isikai.code !== kojin.isikaiCode)) return false;
  }
  if (exclude !== 'collabo' && conditions.collabo) {
    if (!kojin.organ?.some((o) => o.sisetuCode === conditions?.collabo?.code)) return false;
  }
  if (exclude !== 'buka' && conditions.buka) {
    if (!kojin.organ?.some((o) => o.sisetuCode === sisetuCode && (o.bukaCode ?? 'empty') === conditions?.buka?.code)) return false;
  }
  if (exclude !== 'memberClass' && conditions.memberClass) {
    const memberClass = kojin.personalId ? 'member' : 'none';
    if (memberClass !== conditions?.memberClass?.code) return false;
  }
  return true;
}